module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/down-right-2e6e0080a1b0347e14617edda54406c6.svg";